import { useMutation } from "@tanstack/react-query";
import BaseCard from "../../../components/ui/BaseCard";
import { updateTask } from "../../../services/api/task";
import { useUpdateWorkOrder } from "../../../hooks/useUpdateWorkOrder";
import { useDispatch } from "react-redux";
import { showToast } from "../../../store/toast/toastSlice";
import useAuth from "../../../hooks/useAuth";
import { UserType } from "../../../utils/enum";
import BaseTooltip from "../../../components/ui/BaseTooltip";
import BaseButton from "../../../components/ui/BaseButton";
const excludedTaskTypes = [
  "ON_THE_WAY",
  "RUNNING_LATE",
  "MARK_COMPLETE",
  "CHECK_IN",
  "CHECK_OUT",
  "START_TIME",
  "CLOSE_NOTES",
];

const TasksOverview = ({ tasks = {}, mode }) => {
  const { updateWorkOrder } = useUpdateWorkOrder();
  const { authRole } = useAuth();
  const dispatch = useDispatch();
  const {
    isPending: isTaskUpdateApiLoading,
    error: isTaskUpdateError,
    data: updatedTaskData,
    mutateAsync: updateTaskMutation,
  } = useMutation({
    mutationFn: updateTask,
    enabled: false,
  });

  const updateTaskApi = async (id, isCompleted) => {
    /*  if (!engineer) {
      dispatch(
        showToast({
          message: "Work Order is not assigned to you.",
          type: "error",
        })
      );
      return;
    } */

    try {
      let payload = {
        id,
        isCompleted,
      };

      const updatedTask = await updateTaskMutation(payload);

      updateWorkOrder();
    } catch (error) {
      dispatch(
        showToast({
          message: error.response.data.message,
          type: "error",
        })
      );
    }
  };
  const tasksArray = [];

  Object.entries(tasks).forEach(([stageName, tasks]) => {
    tasks.forEach((task) => {
      // Check if the task's type is not in the excluded list
      if (!excludedTaskTypes.includes(task.taskType)) {
        tasksArray.push({
          stage: stageName,
          id: task.id,
          taskType: task.taskType,
          title: task.title,
          isCompleted: task.completedTask?.isCompleted || false,
          completedTask: task?.completedTask,
          completedAt: task.completedTask?.text || null,
          completedBy: task.completedTask?.completedBy
            ? `${task.completedTask.completedBy.firstName} ${task.completedTask.completedBy.lastName}`
            : null,
        });
      }
    });
  });
  return (
    <div className="w-full border rounded mt-4 mb-3">
      <div className="border-bottom mb-4 flex items-center pb-1 ml-6 mt-3 mb-4 mr-6">
        <h6 className={"!text-primary"}>Task Status</h6>
      </div>
      <div className="flex flex-wrap gap-x-3 gap-y-3 mt-4 mb-4 ml-6 mr-6">
        {tasksArray?.map((task) => (
          <div className="flex items-center">
            <div className="flex bg-light items-center rounded-md justify-between py-[4px] px-3 cursor-default text-sm">
              {task?.isCompleted ? (
                <i className="mr-2 fa-solid fa-circle-check text-primary text-sm"></i>
              ) : (
                <i className="mr-2 fa-solid fa-circle-xmark text-secondary text-sm"></i>
              )}

              <BaseTooltip content={task?.completedBy ? `Completed By ${task?.completedBy}` : "Incomplete"}>
                <p className="font-light capitalize text-sm">{task?.title}</p>
              </BaseTooltip>
            </div>

            {mode === "WRITE" && authRole === UserType.FREELANCER && (
              <>
                {task?.completedTask?.isCompleted ? (
                  <BaseButton
                    isLoading={isTaskUpdateApiLoading}
                    loaderSize="16px"
                    color=""
                    className="py-[2px] px-[6px] ml-2 shadow-sm min-w-[28px] h-[28px]"
                    onClick={() => updateTaskApi(task?.completedTask?.id, false)}
                    icon={<i className="fa-solid fa-xmark text-sm"></i>}
                  ></BaseButton>
                ) : (
                  <BaseButton
                    isLoading={isTaskUpdateApiLoading}
                    loaderSize="16px"
                    color=""
                    className="py-[2px] px-[6px] ml-2 shadow-sm min-w-[28px] h-[28px]"
                    onClick={() => updateTaskApi(task?.completedTask?.id, true)}
                    icon={<i className="fa-solid fa-check text-sm"></i>}
                  ></BaseButton>
                )}
              </>
            )}
          </div>
        ))}
      </div>

    </div>
  );
};

export default TasksOverview;
